import { render, staticRenderFns } from "./awDeatils.vue?vue&type=template&id=051780c5&scoped=true&"
import script from "./awDeatils.vue?vue&type=script&lang=js&"
export * from "./awDeatils.vue?vue&type=script&lang=js&"
import style0 from "./awDeatils.vue?vue&type=style&index=0&id=051780c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051780c5",
  null
  
)

export default component.exports